<style scoped lang="less">
.flexx {
	display: flex;
	align-items: center;
}
.classtrainstop {
	height: 5rem;
	padding: 1rem;
	border: 1px solid #ccc;
	border-radius: 5px;
	background-color: #3065bc;
	div {
		margin-right: 1rem;
	}
}

.classtitle {
	margin-top: 1rem;
	width: 100%;
	background-color: #fff;
	box-sizing: border-box;
	padding: 1rem 1rem 0 1rem;
	.classtitle1 {
		width: 35%;
		margin-left: 1.2rem;

		.classtitle1nem {
			font-size: 1.6rem;
			margin-bottom: 15px;
		}

		div {
			font-size: 1rem;
			p {
				margin-right: 40px;
			}
		}
	}
	.classtitle2 {
		width: 20%;
		position: absolute;
		right: 0%;
		bottom: 1%;
	}
	.classnametiltle {
		width: 20%;
		font-size: 2rem;
		margin-bottom: 4rem;
	}

	.tablists {
		margin-top: 1rem;
		padding: 1rem 1rem 0 1rem;
		border-top: 1px solid #ccc;

		div {
			width: 18%;
			text-align: center;
			height: 2.4rem;
			font-size: 1.2rem;
			cursor: pointer;
		}

		.actives {
			color: #3399ff;
			border-bottom: 4px solid #3399ff;
		}
	}
}

.classdatatotle {
	margin: 1rem 0;
	padding: 1rem;
	background-color: #fff;

	.trainstitle {
		padding-bottom: 10px;
		border-bottom: 1px solid #ccc;
	}

	.trainschat {
		margin-top: 1rem;
		.trainschat1 {
			width: 20%;
			// margin-left: 2rem;

			.rebilctfont {
				padding: 10px;
				border: 1px solid #ff5c00;
				color: #fff;
				background-color: #ff5c00;
				border-radius: 5px;
				font-size: 1rem;
			}
			.rebilctfontdata {
				border: 1px solid #ff5c00;
				border-radius: 2px;
				margin-top: 1rem;
				padding: 10px;
				p {
					padding: 20px 10px;
					font-size: 1rem;
					border-bottom: 1px solid #ff5c00;
				}
			}
		}

		.trainschat2 {
			margin-left: 1rem;
			width: 41%;
			height: 25rem;
			// border: 1px solid #ff5c00;
			.trainschatfont {
				font-size: 1.1rem;
				margin-top: 1rem;
				margin-left: 20px;
			}
		}
	}
}

.responstbilteall {
	.rebuilctlischat {
		width: 40%;
		height: 28rem;
		// border: 1px solid #ff5c00;
		margin-top: 1rem;
	}

	.rebuilctlistdataitme {
		width: 48%;
		margin: 1rem 1%;
		border: 1px solid #d9d9d9;
		border-radius: 8px;
		box-sizing: border-box;
		padding: 10px;
		align-items: flex-start;
		height: 12rem;
		overflow: hidden;
		.cilcle {
			width: 60px;
			height: 60px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px solid;
			margin-right: 10px;
			background-color: #ff0000;
			color: #fff;
			font-size: 1.8rem;
		}

		.stdataitmefont {
			.stdataitmecontent {
				width: 90%;
				font-size: 1rem;
				padding: 0 10px;
				box-sizing: border-box;
				overflow: hidden;
			}
			p {
				font-size: 1.5rem;
				margin-bottom: 1rem;
			}
		}
	}

	.rebuilctlistdata {
		flex-wrap: wrap;
		margin-left: 1rem;
		.rebuilctlistdataitme {
			width: 48%;
			margin: 1rem 1%;
			border: 1px solid #d9d9d9;
			border-radius: 8px;
			box-sizing: border-box;
			padding: 10px;
			align-items: flex-start;
			height: 12rem;
			overflow: hidden;
			.cilcle {
				width: 60px;
				height: 60px;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				border: 1px solid;
				margin-right: 10px;
				background-color: #ff0000;
				color: #fff;
				font-size: 1.8rem;
			}

			.stdataitmefont {
				.stdataitmecontent {
					width: 90%;
					font-size: 1rem;
					padding: 0 10px;
					box-sizing: border-box;
					overflow: hidden;
				}
				p {
					font-size: 1.5rem;
					margin-bottom: 1rem;
				}
			}
		}
	}
}

.responstbilteall {
	.classreabilct {
		height: 30rem;
		width: 100%;
	}
}

.classreabilctexr {
	height: 22rem;
	padding: 1rem 0;
	box-sizing: border-box;
}

.responsbilict {
	height: 24rem;
	// padding: 1rem 0;
}

.traintimers {
	height: 24rem;
}

.rebuilctlistdata {
	margin-right: 10px;
	scroll-snap-align: start;
}
.scoolct {
	height: 28rem;
	/deep/ .el-carousel {
		height: 100%;
		.el-carousel__container {
			position: inherit !important;
			height: 100% !important;
		}
	}
}

/* 滚动条整体样式 */
.scoolct::-webkit-scrollbar {
	width: 10px; /* 宽度 */
	height: 10px; /* 高度 */
}
/* 滚动槽 */
.scoolct::-webkit-scrollbar-track {
	background-color: #fff; /* 背景色 */
	border-radius: 5px; /* 圆角 */
}
/* 滚动条滑块 */
.scoolct::-webkit-scrollbar-thumb {
	background-color: #48da6a; /* 背景色 */
	border-radius: 5px; /* 圆角 */
}
/* 滚动条滑块悬停样式 */
.scoolct::-webkit-scrollbar-thumb:hover {
	background-color: #fff; /* 背景色 */
}
</style>
<template>
	<div>
		<titles titlename="班级实训档案" titlecontent="这里可以看到班级实训档案" :mbx="paths"></titles>
		<div class="classtrainstop flexx">
			<div style="width: 15%;">
				<el-select v-model="schoolvalue" placeholder="请选择院校" style="width: 100%;" @change="changesschools()">
					<el-option v-for="item in schoollists" :key="item.si_guid" :label="item.si_name_cn" :value="item.si_guid"></el-option>
				</el-select>
			</div>
			<div style="width: 15%;">
				<el-select v-model="classvalue" placeholder="请选择班级" style="width: 100%;">
					<el-option v-for="item in classnamelist" :key="item.cla_guid" :label="item.cla_name" :value="item.cla_guid"></el-option>
				</el-select>
			</div>
			<div style="width: 15%;">
				<el-select v-model="stevalue" placeholder="请选择设备" style="width: 100%;">
					<el-option v-for="item in stenamelist" :key="item.sx_te_guid" :label="item.te_deviceName" :value="item.sx_te_guid"></el-option>
				</el-select>
			</div>
			<!-- <div style="width: 20%;"><el-input v-model="classnameinput" placeholder="请输入内容"></el-input></div> -->
			<div>
				<el-button @click="changefxs()" style="width: 150px;" type="success" icon="el-icon-search">分析</el-button>
				<!-- <el-button @click="getschoollist()" icon="el-icon-refresh-right">重置</el-button> -->
			</div>
		</div>

		<div id="pdf-container" ref="pdfcontainer" style="width: 100%;">
			<div class="classtitle">
				<div class="flexx" style="position: relative;">
					<img style="margin-left: 1rem; width: 100px;height: 100px;" :src="schoollisobj.si_pictureUrl ? schoollisobj.si_pictureUrl : '@/images/gtsdschool.png'" alt="" />
					<div class="classtitle1">
						<p class="classtitle1nem">{{ classnameobj.cla_name }}</p>
						<div class="classnos">
							<div class="flexx">
								<p>班级编号：{{ classnameobj.cla_nameNumber }}</p>
								<p>所属专业：{{ classnameobj.pro_name }}</p>
							</div>
							<div class="flexx">
								<!-- <p>课程老师：张学友</p> -->
								<p>所属院校：{{ classnameobj.si_name_cn }}</p>
							</div>
						</div>
					</div>
					<p class="classnametiltle">班级实训档案</p>
					<div class="classtitle2">
						<el-button icon="el-icon-edit" @click="printBox">打印</el-button>
						<el-button icon="el-icon-download" @click="downloadPDF">下载</el-button>
					</div>
				</div>
				<div class="tablists flexx">
					<div ref="scrollTotablists1" :class="{ actives: isactives == 1 }" @click="changetablist(1)">实训数据统计</div>
					<div ref="scrollTotablists2" :class="{ actives: isactives == 2 }" @click="changetablist(2)">综合能力评估</div>
					<div ref="scrollTotablists3" :class="{ actives: isactives == 3 }" @click="changetablist(3)">班级能力对比</div>
				</div>
			</div>

			<div class="classdatatotle">
				<div class="trainstitle flexx">
					<span style="display: block;width: 6px;height: 20px;margin-right: 10px;border-radius: 2px;background-color: #58A3F7;"></span>
					<p style="font-size: 1.2rem;font-weight: 600;">实训数据统计</p>
				</div>
				<div class="trainschat flexx">
					<div class="trainschat1">
						<div class="rebilctfont">能力掌握程度：{{ classdataobj.classnum }}</div>
						<div class="rebilctfontdata">
							<p>总人数：{{ classdataobj.projectSum }}</p>
							<p>优秀占比：{{ classdataobj.projectBestPercentage }}% （{{ classdataobj.projectBest }}人）</p>
							<p>良好占比： {{ classdataobj.projectGoodPercentage }}% （{{ classdataobj.projectGood }}人）</p>
							<p>一般占比：{{ classdataobj.projectGeneralPercentage }}% （{{ classdataobj.projectGeneral }}人）</p>
							<p>未掌握占比： {{ classdataobj.projectNotmasteredPercentage }}% （{{ classdataobj.projectNotmastered }}人）</p>
							<p>未测评： {{ classdataobj.projectNotEvaluatedPercentage }}% （{{ classdataobj.projectNotEvaluated }}人）</p>
						</div>
					</div>

					<div class="trainschat2">
						<div class="trainschatfont">能力掌握程度</div>
						<div class="responsbilict" id="responsbilict"></div>
					</div>
					<div class="trainschat2">
						<div class="trainschatfont">实训时长</div>
						<div class="traintimers" id="traintimers"></div>
					</div>
				</div>
			</div>

			<div class="responstbilteall classdatatotle">
				<div class="trainstitle flexx">
					<span style="display: block;width: 6px;height: 20px;margin-right: 10px;border-radius: 2px;background-color: #58A3F7;"></span>
					<p style="font-size: 1.2rem;font-weight: 600;">综合能力评估</p>
				</div>
				<el-empty v-show="isclassdatarshow == 0" description="暂无评估数据"></el-empty>
				<div class="rebuilctlis flexx" v-show="isclassdatarshow == 1">
					<div class="rebuilctlischat" ref="rebuilctlischat" id="rebuilctlischat"></div>
					<div class="scoolct" style="width: 60%;overflow-x: scroll;">
						<el-carousel indicator-position="none" :autoplay="false" :loop="false">
							<el-carousel-item v-for="(item, index) in classdatarbildctlist" :key="index">
								<div class="rebuilctlistdata flexx">
									<div class="rebuilctlistdataitme flexx" v-for="(ite, indx) in item" :key="indx">
										<div style="width: 20%;" title="最高分">
											<p class="cilcle">{{ Math.round(ite.projectAVG) }}</p>
										</div>
										<div class="stdataitmefont">
											<p>{{ ite.projectTypeName }}</p>
											<div class="stdataitmecontent">
												优秀人数占比： {{ ite.projectBest }} %，良好人数占比： {{ ite.projectGood }} %，一般人数占比：
												{{ ite.projectGeneral }} %，未掌握人数占比 {{ ite.projectmastered }} %，未评测人数占比： {{ ite.projectNoFailing }} %。
											</div>
										</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
			</div>

			<div class="responstbilteall classdatatotle" style="margin-bottom: 2vh;">
				<div class="trainstitle flexx">
					<span style="display: block;width: 6px;height: 20px;margin-right: 10px;border-radius: 2px;background-color: #58A3F7;"></span>
					<p style="font-size: 1.2rem;font-weight: 600;">班级能力对比</p>
				</div>

				<div v-show="classreabilctoption.series.length > 0" class="classreabilctexr" id="classreabilctexr"></div>
				<el-empty v-show="classreabilctoption.series.length == 0" description="暂无能力数据"></el-empty>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import 'echarts/lib/chart/bar';

import html2canvas from 'html2canvas';

import AppOptions from '@/config/AppOptions.vue';

import { scoollist } from '@/request/alllog.js';

import { splitArray } from '@/utils/utils.js';

import { GetyyGetClassList, GetClassInfoTainTimeLengthSTA, GetClassInfoTainTimeLengthSTApi, GetMyClatypeTrainDataApi } from '@/request/api/dataorder/dataprder.js';

import { getGetMyclaTrainData, GetMyclaTrainDataApi, getGetMyTypeclaTrainData, getGetMyClaTraiTypeData, GetMyTypeclaTrainDataApi } from '@/request/api/pingtai/trainsplan.js';
import { GetyyTrainEquipmentList } from '@/request/api/dataorder/dataprder';
export default {
	data() {
		return {
			classvalue: '',
			isactives: 1,
			// 标题
			paths: [
				{
					path: '/allmanage/trainingpractical',
					name: '班级实训档案'
				}
			],
			// 院校下拉列表
			schoollists: [],
			classnamelist: [],
			schoollisobj: {},
			classnameobj: {},
			schoolvalue: '',
			classnameinput: '',
			// 综合能力评估
			isclassdatarshow: 1,
			responstbilteoption: {
				tooltip: {
					trigger: 'axis'
				},
				radar: {
					indicator: [{}],
					splitArea: {
						show: true,
						areaStyle: {
							color: ['rgba(157,200,241,0.1)', 'rgba(157,200,241,0.3)', 'rgba(157,200,241,0.1)', 'rgba(157,200,241,0.3)']
						}
					},
					splitLine: {
						lineStyle: {
							color: '#ccc'
						}
					},
					axisLine: {
						lineStyle: {
							width: 1,
							color: '#ccc'
						}
					}
				},
				series: [
					{
						name: '能力统计',
						type: 'radar',
						barWidth: null,
						tooltip: {
							trigger: 'item'
						},
						itemStyle: {
							color: '#9DC8F1'
						},
						lineStyle: {
							color: '#9DC8F1'
						},
						areaStyle: {
							color: '#9DC8F1',
							opacity: 0.8
						},
						data: [
							{
								value: [],
								name: '能力统计'
							}
						]
					}
				]
			},
			classreabilctoption: {
				color: ['#73A0FA', '#73DEB3'],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				legend: {
					show: true,
					data: [],
					left: '4%'
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: ['优秀人数占比', '良好人数占比', '一般人数占比', '未掌握人数占比', '未评测人数占比']
				},
				yAxis: {
					type: 'value',
					axisLabel: { formatter: '{value} 人' }
				},
				series: []
			},
			responsbilictcharts: {
				color: ['#6ADCAF', '#6D7E9D', '#6395F9', '#F7C32D'],
				tooltip: {
					trigger: 'item'
				},
				legend: {
					orient: 'vertical',
					left: 'left',
					show: false
				},
				grid: {
					left: '1%',
					right: '0',
					left: '0',
					bottom: '0',
					containLabel: true,
					borderWidth: 5
				},
				stillShowZeroSum: true,
				series: [
					{
						name: '能力掌握程度',
						type: 'pie',
						radius: '50%',
						center: ['50%', '50%'], // 默认全局居中
						radius: [0, '80%'],
						stillShowZeroSum: true,
						color: [
							'#8085e9',
							'#f15c80',
							'#e4d354',
							'#2b908f',
							'#f45b5b',
							'#91e8e1',
							'#058DC7',
							'#50B432',
							'#ED561B',
							'#DDDF00',
							'#24CBE5',
							'#64E572',
							'#FF9655',
							'#FFF263',
							'#6AF9C4',
							'#D47F00',
							'#00FFFF',
							'#D4FF55',
							'#4572A7',
							'#AA4643',
							'#89A54E',
							'#80699B',
							'#3D96AE',
							'#DB843D',
							'#92A8CD',
							'#A47D7C',
							'#7FBF55',
							'#a5c2d5',
							'#cbab4f',
							'#76a871',
							'#90ed7d',
							'#f7a35c',
							'#a56f8f',
							'#c12c44',
							'#9f7961',
							'#76a871',
							'#6f83a5',
							'0f4fb8',
							'106dcf',
							'#b3d74c',
							'#74aae3',
							'#5cdec6',
							'#3526de',
							'#9d65ee',
							'#a8b3e3',
							'#6bc1b7',
							'549ee2',
							'#6e98d6'
						],
						itemStyle: {
							normal: {
								borderWidth: 100
							}
						},
						data: [
							{ value: 22, name: '一般人数 22人' },
							{ value: 30, name: '良好人数 30人' },
							{ value: 58, name: '优秀人数 58' },
							{ value: 48, name: '未掌握人数  48人' }
						],
						markPoint: {
							symbol: 'circle',
							symbolSize: 0,
							label: {
								show: false
							},
							data: [
								{
									xAxis: 0,
									yAxis: 0
								}
							]
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			},
			traintimerscharts: {
				color: '#73A0FA',
				xAxis: {
					type: 'category',
					data: ['1月份', '2月份', '3月份', '4月份', '5月份', '6月份', '7月份', '8月份', '9月份', '10月份', '11月份', '12月份']
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				yAxis: {
					type: 'value',
					// name:"单位（分钟）"
					axisLabel: { formatter: '{value} 分钟' }
				},
				legend: {
					show: true
				},
				grid: {
					top: '5%',
					right: '3%',
					left: '14%',
					bottom: '5%'
				},
				series: [
					{
						data: [],
						type: 'bar',
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)'
						}
					}
				]
			},
			myCharts1: {},
			myCharts2: {},
			myCharts3: {},
			myCharts4: {},
			// 班级实训统计
			classdataobj: {},
			// 综合能力评估
			classdatarbildctlist: [],
			// 设备筛选
			stevalue: '',
			stenamelist: []
		};
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		this.getresponstbilte();
		this.getclassreabilct();

		window.addEventListener('scroll', this.handleScroll); // 监听页面滚动
		this.getschoollist();

		let myCharts1 = this.$echarts.getInstanceByDom(document.getElementById('rebuilctlischat'));
		let myCharts2 = this.$echarts.getInstanceByDom(document.getElementById('classreabilctexr'));
		let myCharts3 = this.$echarts.getInstanceByDom(document.getElementById('responsbilict'));
		let myCharts4 = this.$echarts.getInstanceByDom(document.getElementById('traintimers'));

		window.addEventListener('resize', function() {
			if (this.myCharts1) {
				this.myCharts1.resize();
			}
			if (this.myCharts2) {
				this.myCharts2.resize();
			}
			if (this.myCharts3) {
				this.myCharts3.resize();
			}
			if (this.myCharts4) {
				this.myCharts4.resize();
			}
		});
	},
	methods: {
		// 获取设备
		getstelist() {
			GetyyTrainEquipmentList(this.schoolvalue).then(res => {
				// console.log('设备列表', res.data.data);
				this.stenamelist = res.data.data;
				if (this.stenamelist.length > 0) {
					this.stevalue = this.stenamelist[0].sx_te_guid;
					this.gettypecla();
					this.getclasstriandata();
				}
			});
		},

		changefxs() {
			this.classnamelist.forEach(item => {
				if (this.classvalue == item.cla_guid) {
					this.classnameobj = item;
				}
			});
			this.gettypecla();
			this.getclasstriandata();
		},

		// 更换学校
		changesschools() {
			this.schoollists.forEach(item => {
				if (this.schoolvalue == item.si_guid) {
					this.schoollisobj = item;
					GetyyGetClassList(this.schoolvalue).then(rees => {
						this.classnamelist = rees.data.data;
						if (rees.data.data[0]) {
							this.classvalue = rees.data.data[0].cla_guid ?? '';
							this.classnameobj = rees.data.data[0];
							this.getstelist();
						} else {
							this.classvalue = '';
							this.classnameobj = {};
							this.classnameobj.cla_name = '暂无班级';
							this.classnameobj.cla_nameNumber = '暂无班级';
							this.classnameobj.pro_name = '暂无专业';
							this.classnameobj.si_name_cn = item.si_name_cn;
							this.schoollisobj.si_pictureUrl = null;
							this.classdataobj = {};
							this.classdataobj.projectBest = 0;
							this.classdataobj.projectGood = 0;
							this.classdataobj.projectGeneral = 0;
							this.classdataobj.projectNotmastered = 0;
							this.classdataobj.projectNotEvaluated = 0;
							this.classdataobj.classnum = 0;
							this.classdataobj.projectSum = 0;
							this.classdataobj.projectBestPercentage = 0;
							this.classdataobj.projectGoodPercentage = 0;
							this.classdataobj.projectGeneralPercentage = 0;
							this.classdataobj.projectNotmasteredPercentage = 0;
							this.classdataobj.projectNotEvaluatedPercentage = 0;
						}
						// console.log(this.classvalue, '获取');
					});
				}
			});
		},

		getMyclaTraiTyp() {
			// getGetMyClaTraiTypeData(this.classvalue).then(res => {
			GetMyClatypeTrainDataApi({
				cla_guid: this.classvalue,
				sx_te_guid: this.stevalue
			}).then(res => {
				// console.log(res, '获取res');

				if (res.data.data.length > 0) {
					this.isclassdatarshow = 1;
					this.classdatarbildctlist = splitArray(res.data.data, 4);
					this.responstbilteoption.radar.indicator = [];
					this.responstbilteoption.series[0].data[0].value = [];
					let clatraintylist = [];
					let clatraintyneme = [];
					res.data.data.forEach(item => {
						clatraintylist.push(item.projectAVG);
					});
					let maxdata = Math.max(...clatraintylist);

					res.data.data.forEach(item => {
						clatraintyneme.push({
							name: item.projectTypeName,
							max: maxdata + 10
						});
					});
					// console.log(clatraintyneme, '获取本地服务');
					this.responstbilteoption.radar.indicator = clatraintyneme;
					this.responstbilteoption.series[0].data[0].value = clatraintylist;
					this.getresponstbilte();
				} else {
					this.isclassdatarshow = 0;
				}

				/* 
				else{
					this.responstbilteoption.radar.indicator = []
					this.responstbilteoption.series[0].data[0].value = []
					this.getresponstbilte();
				} 
				 
				 */

				// console.log(this.responstbilteoption.radar.indicator,,'获取能力评估')
			});
		},
		gettypecla() {
			// getGetMyTypeclaTrainData(this.schoolvalue).then(res => {
			GetMyTypeclaTrainDataApi({
				si_guid: this.schoolvalue,
				sx_te_guid: this.stevalue
			}).then(res => {
				// console.log(res.data.data,'获取班级能力对比')
				if (res.data.data.length > 0) {
					let pushtypeobj = {
						itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: {
										//数值样式
										color: 'black',
										fontSize: 16
									}
								}
							}
						},
						name: '班级二',
						data: [],
						type: 'bar'
					};

					let legenddatanamelist = [];
					// console.log(res.data.data)
					let serigvtslist = [];
					res.data.data.forEach(item => {
						legenddatanamelist.push({
							name: item.cla_name
						});
						let pushtypeobj = {};
						pushtypeobj.name = item.cla_name + '';
						pushtypeobj.data = [item.projectBest, item.projectGood, item.projectGeneral, item.projectmastered, item.projectNotEvaluated];
						pushtypeobj.type = 'bar';
						// console.log(pushtypeobj)
						serigvtslist.push(pushtypeobj);
					});
					if (serigvtslist.length > 6) {
						serigvtslist = serigvtslist.slice(0, 6);
					}
					this.classreabilctoption.legend.data = legenddatanamelist;
					this.classreabilctoption.series = serigvtslist;
					// console.log(this.classreabilctoption,'获取班级能力对比222')
				} else {
					this.classreabilctoption.series = [];
				}
				setTimeout(() => {
					this.getclassreabilct();
				}, 200);
				// console.log(res.data.data, '获取数组');
			});
		},

		gettimerstrains() {
			let TimeLengthobj = {
				cla_guid: this.classvalue,
				timetype: 'year',
				parms: new Date().getFullYear(),
				sx_te_guid: this.stevalue
			};

			// GetClassInfoTainTimeLengthSTA(TimeLengthobj).then(res => {
			GetClassInfoTainTimeLengthSTApi(TimeLengthobj).then(res => {
				if (res.data.data.length > 0) {
					let traintimerschartsseries = [];
					let traintimersdata = [];

					res.data.data.forEach(item => {
						traintimerschartsseries.push(item.count);
					});
					this.traintimerscharts.series[0].data = traintimerschartsseries;
					this.gettraintimers();
				}
			});
		},

		getclasstriandata() {
			// getGetMyclaTrainData(this.classvalue).then(res => {
			GetMyclaTrainDataApi({
				cla_guid: this.classvalue,
				sx_te_guid: this.stevalue
			}).then(res => {
				// console.log(res.data.data, '能力掌握程度');
				if (res.data.data) {
					for (var i in res.data.data) {
						if (!res.data.data[i]) {
							res.data.data[i] = 0;
						}
					}

					this.classdataobj = res.data.data;
					this.classdataobj.classnum =
						parseInt(this.classdataobj.projectBest) +
						parseInt(this.classdataobj.projectBest) +
						parseInt(this.classdataobj.projectGood) +
						parseInt(this.classdataobj.projectGeneral);

					let listclass = [
						this.classdataobj.projectBest,
						this.classdataobj.projectGood,
						this.classdataobj.projectGeneral,
						this.classdataobj.projectNotmastered,
						this.classdataobj.projectNotEvaluated
					];

					let classchartslist = [
						{ value: this.classdataobj.projectBest == 0 ? 1 : this.classdataobj.projectBest, name: '优秀人数' + this.classdataobj.projectBest + '人' },
						{ value: this.classdataobj.projectGood == 0 ? 1 : this.classdataobj.projectGood, name: '良好人数 ' + this.classdataobj.projectGood + '人' },
						{ value: this.classdataobj.projectGeneral == 0 ? 1 : this.classdataobj.projectGeneral, name: '一般人数' + this.classdataobj.projectGeneral },
						{
							value: this.classdataobj.projectNotmastered == 0 ? 1 : this.classdataobj.projectNotmastered,
							name: '未掌握人数  ' + this.classdataobj.projectNotmastered + '人'
						},
						{
							value: this.classdataobj.projectNotEvaluated == 0 ? 1 : this.classdataobj.projectNotEvaluated,
							name: '未测评人数  ' + this.classdataobj.projectNotEvaluated + '人'
						}
					];

					if (listclass.filter(ite => ite > 0).length > 0) {
						classchartslist = [
							{ value: this.classdataobj.projectBest, name: '优秀人数' + this.classdataobj.projectBest + '人' },
							{ value: this.classdataobj.projectGood, name: '良好人数 ' + this.classdataobj.projectGood + '人' },
							{ value: this.classdataobj.projectGeneral, name: '一般人数' + this.classdataobj.projectGeneral },
							{ value: this.classdataobj.projectNotmastered, name: '未掌握人数  ' + this.classdataobj.projectNotmastered + '人' },
							{ value: this.classdataobj.projectNotEvaluated, name: '未测评人数  ' + this.classdataobj.projectNotEvaluated + '人' }
						];
					}
					this.responsbilictcharts.series[0].data = classchartslist.filter(item => item.value > 0);

					this.getclasscharts();

					// 请求1111
					this.gettimerstrains();
					this.getMyclaTraiTyp();
				}
			});
		},

		// 获取院校列表班级
		getschoollist() {
			scoollist().then(res => {
				// console.log(res)
				if (res.data.data.length > 0) {
					this.schoollists = res.data.data;
					if (res.data.data.length > 0 && res.data.data[0].si_guid) {
						this.schoolvalue = res.data.data[0].si_guid;
						this.schoollisobj = res.data.data[0];
						GetyyGetClassList(this.schoolvalue).then(rees => {
							this.classnamelist = rees.data.data;
							if (rees.data.data && rees.data.data[0]) {
								this.classvalue = rees.data.data[0].cla_guid ?? '';
								this.classnameobj = rees.data.data[0];

								this.getstelist();
							}
						});
					}
				}
			});
		},

		getresponstbilte() {
			let charts = document.getElementById('rebuilctlischat');
			let myCharts1 = this.$echarts.getInstanceByDom(charts);
			myCharts1 = this.$echarts.init(charts);
			// console.log(myCharts1);
			this.myCharts1 = myCharts1;
			myCharts1.setOption(this.responstbilteoption);
		},

		getclassreabilct() {
			let getelement = document.getElementById('classreabilctexr');
			this.$echarts.init(getelement);
			let myCharts2 = this.$echarts.getInstanceByDom(getelement);
			this.myCharts2 = myCharts2;
			myCharts2.resize();
			// console.log(getelement,'图表');
			myCharts2.setOption(this.classreabilctoption);
		},
		getclasscharts() {
			let getelement1 = document.getElementById('responsbilict');
			this.$echarts.init(getelement1);
			let myCharts3 = this.$echarts.getInstanceByDom(getelement1);
			this.myCharts3 = myCharts3;

			myCharts3.setOption(this.responsbilictcharts);
		},
		gettraintimers() {
			let getelement2 = document.getElementById('traintimers');
			this.$echarts.init(getelement2);
			let myCharts4 = this.$echarts.getInstanceByDom(getelement2);
			this.myCharts4 = myCharts4;
			myCharts4.setOption(this.traintimerscharts);
		},
		// 滚动
		// 获取页面滚动距离
		handleScroll() {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			// console.log(scrollTop, '滚动距离');
			if (scrollTop < 200) {
				this.isactives = 1;
			} else if (scrollTop > 200 && scrollTop < 500) {
				this.isactives = 2;
			} else if (scrollTop > 500) {
				this.isactives = 3;
			}
		},
		// 滚动重置
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		changetablist(num) {
			this.isactives = num;

			if (num == 1) {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
				// this.scrollToElement(this.$refs.scrollTotablists1);
			} else if (num == 2) {
				window.scrollTo({
					top: 400,
					behavior: 'smooth'
				});
				// this.scrollToElement(this.$refs.scrollTotablists2);
			} else {
				window.scrollTo({
					top: 840,
					behavior: 'smooth'
				});
				// this.scrollToElement(this.$refs.scrollTotablists3);
			}
		},
		scrollToElement(dom) {
			dom.scrollIntoView({ behavior: 'smooth', block: 'start' });
		},
		// 下载pdf
		downloadPDF() {
			const element = document.getElementById('pdf-container');

			html2canvas(element, {
				scrollY: -window.scrollY,
				windowHeight: document.documentElement.scrollHeight
			})
				.then(canvas => {
					// console.log(canvas)
					const imgData = canvas.toDataURL('image/png');
					// console.log(imgData)
					const a = document.createElement('a');
					a.href = imgData;
					a.download = 'image.png';
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				})
				.catch(err => {
					console.log(err);
				});
		},
		// 打印
		printBox() {
			const element = document.getElementById('pdf-container');
			html2canvas(element, {
				scrollY: -window.scrollY,
				windowHeight: document.documentElement.scrollHeight
			})
				.then(canvas => {
					// console.log(canvas)
					const imgData = canvas.toDataURL('image/png');
					const image = new Image();
					image.src = imgData;
					image.onload = function() {
						canvas.width = image.width;
						canvas.height = image.height;
						const context = canvas.getContext('2d');
						context.drawImage(image, 0, 0);
						const dataUrl = canvas.toDataURL('image/png');
						const printContent = window.open('', '', 'width=800,height=600');
						printContent.document.write('<img src="' + dataUrl + '">');
						printContent.print();
						printContent.close();
					};
				})
				.catch(err => {
					console.log(err);
				});
		}
	},
	components: {
		titles
	}
};
</script>
